// extracted by mini-css-extract-plugin
module.exports = {"accordionComponentWrapper":"jT","header":"jU","accordionWrapper":"jV","accordionHeader":"jW","accordionIcon":"jX","accordionContent":"jY"};